import { render, staticRenderFns } from "./UpdateNotifyTime.vue?vue&type=template&id=e6f5ea9e&"
import script from "./UpdateNotifyTime.vue?vue&type=script&lang=js&"
export * from "./UpdateNotifyTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports